package com.evoapps.evoshift.ui.user

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Badge
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.ChevronRight
import androidx.compose.material.icons.filled.Description
import androidx.compose.material.icons.filled.EditCalendar
import androidx.compose.material.icons.filled.EventAvailable
import androidx.compose.material.icons.filled.Groups
import androidx.compose.material.icons.filled.HealthAndSafety
import androidx.compose.material.icons.filled.Inbox
import androidx.compose.material.icons.filled.Layers
import androidx.compose.material.icons.filled.Payments
import androidx.compose.material.icons.filled.PersonAdd
import androidx.compose.material.icons.filled.PointOfSale
import androidx.compose.material.icons.filled.Publish
import androidx.compose.material.icons.filled.RadioButtonUnchecked
import androidx.compose.material.icons.filled.Schedule
import androidx.compose.material.icons.filled.Storefront
import androidx.compose.material.icons.filled.SwapHoriz
import androidx.compose.material.icons.filled.TaskAlt
import androidx.compose.material.icons.filled.Timer
import androidx.compose.material.icons.filled.ViewWeek
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.evoapps.evoshift.ui.util.asString
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.layout.Layout
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.Constraints
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.StaffCheck
import com.evoapps.evoshift.domain.usecase.todo.TodoItem
import com.evoapps.evoshift.domain.usecase.todo.TodoKind
import com.evoapps.evoshift.domain.usecase.todo.TodoRules
import com.evoapps.evoshift.domain.util.AppClock
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.util.monthInSentence
import com.evoapps.evoshift.ui.util.dayAndMonth
import com.evoapps.evoshift.viewmodels.TodoUiState
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.capacity_reminder_message
import evoshift.composeapp.generated.resources.capacity_reminder_message_due
import evoshift.composeapp.generated.resources.capacity_reminder_title
import evoshift.composeapp.generated.resources.missing_pay_set
import evoshift.composeapp.generated.resources.todo_all_done
import evoshift.composeapp.generated.resources.todo_all_done_hint
import evoshift.composeapp.generated.resources.todo_availability_answers
import evoshift.composeapp.generated.resources.todo_availability_due
import evoshift.composeapp.generated.resources.todo_availability_fill
import evoshift.composeapp.generated.resources.todo_clock_reviews
import evoshift.composeapp.generated.resources.todo_clock_reviews_action
import evoshift.composeapp.generated.resources.todo_day_today
import evoshift.composeapp.generated.resources.todo_day_tomorrow
import evoshift.composeapp.generated.resources.todo_deadline
import evoshift.composeapp.generated.resources.todo_earliest
import evoshift.composeapp.generated.resources.todo_earliest_named
import evoshift.composeapp.generated.resources.todo_hours_to_confirm
import evoshift.composeapp.generated.resources.todo_hours_to_confirm_action
import evoshift.composeapp.generated.resources.todo_marketplace
import evoshift.composeapp.generated.resources.todo_marketplace_action
import evoshift.composeapp.generated.resources.todo_medical_expired
import evoshift.composeapp.generated.resources.todo_medical_expiring
import evoshift.composeapp.generated.resources.todo_missing_pay
import evoshift.composeapp.generated.resources.todo_missing_pay_others
import evoshift.composeapp.generated.resources.todo_missing_takings
import evoshift.composeapp.generated.resources.todo_missing_takings_action
import evoshift.composeapp.generated.resources.todo_my_shifts
import evoshift.composeapp.generated.resources.todo_next_shift
import evoshift.composeapp.generated.resources.todo_ohs_expired
import evoshift.composeapp.generated.resources.todo_ohs_expiring
import evoshift.composeapp.generated.resources.todo_open
import evoshift.composeapp.generated.resources.todo_open_roster
import evoshift.composeapp.generated.resources.todo_policies
import evoshift.composeapp.generated.resources.todo_policies_action
import evoshift.composeapp.generated.resources.todo_publish
import evoshift.composeapp.generated.resources.todo_publish_changes
import evoshift.composeapp.generated.resources.roster_unpublished_count
import evoshift.composeapp.generated.resources.todo_remind
import evoshift.composeapp.generated.resources.todo_reminded
import evoshift.composeapp.generated.resources.todo_requests
import evoshift.composeapp.generated.resources.todo_requests_action
import evoshift.composeapp.generated.resources.todo_starts_in_hours
import evoshift.composeapp.generated.resources.todo_starts_in_minutes
import evoshift.composeapp.generated.resources.todo_swap_asked
import evoshift.composeapp.generated.resources.todo_swap_rejected
import evoshift.composeapp.generated.resources.todo_swaps_asked
import evoshift.composeapp.generated.resources.todo_title
import evoshift.composeapp.generated.resources.todo_unfilled
import evoshift.composeapp.generated.resources.todo_view
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.plus
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource

/** SH-170: test tag of the "Do zrobienia" card, and of each of its rows (by [TodoKind]). */
const val TODO_CARD_TAG = "todo_card"
fun todoItemTag(kind: TodoKind) = "todo_item_${kind.name}"
fun todoActionTag(kind: TodoKind) = "todo_action_${kind.name}"

/** An item's urgency colour: dark enough on the white card (WCAG 4.5:1). */
private val UrgentColor = Color(0xFFB45309)
private val DoneColor = Color(0xFF2E7D32)

/**
 * SH-170: what the to-do rows open or do. The screens are the app's (App.kt); a row whose action
 * is missing (null) shows no button.
 */
class TodoActions(
    val openRequests: (() -> Unit)? = null,
    /** Brings today's clock-in review list into view (it is on the dashboard). */
    val showClockReview: (() -> Unit)? = null,
    val enterTakings: ((workplaceId: String, date: LocalDate) -> Unit)? = null,
    /** SH-257: Godziny pracy on a day ("Potwierdź godziny z wczoraj"). */
    val openWorkHours: ((workplaceId: String, date: LocalDate) -> Unit)? = null,
    val openPay: ((workplaceId: String, userId: String) -> Unit)? = null,
    val openRoster: ((rosterId: String) -> Unit)? = null,
    val openCapacity: ((rosterId: String) -> Unit)? = null,
    /** "Przypomnij" with the push text in the sender's language. */
    val remind: ((TodoItem.AvailabilityAnswers, title: String, message: String) -> Unit)? = null,
    val openMyShifts: (() -> Unit)? = null,
    val openAvailability: ((rosterId: String) -> Unit)? = null,
    val openPolicies: ((workplaceId: String) -> Unit)? = null,
    val openProfile: (() -> Unit)? = null,
    val openMarketplace: (() -> Unit)? = null
)

/** One row as it reads: its title, a line under it, and its one action. */
private data class TodoRow(
    val icon: ImageVector,
    val title: String,
    val detail: String?,
    val actionLabel: String?,
    val action: (() -> Unit)?,
    /** The action is done already (a reminder sent): shown, not tappable. */
    val actionDone: Boolean = false
)

/**
 * SH-170: "Do zrobienia" at the top of every home screen: one list, most urgent first, each row
 * with its one action (done here, or the screen where it is done). "Wszystko zrobione" when
 * nothing waits; SH-247: its placeholder (the title and a few rows) until the first list arrived.
 */
@Composable
fun TodoCard(state: TodoUiState, actions: TodoActions, modifier: Modifier = Modifier, onMessageShown: () -> Unit = {}) {
    com.evoapps.evoshift.widgets.LoadingSwap(
        known = state.loaded,
        modifier = modifier.fillMaxWidth(),
        placeholder = { com.evoapps.evoshift.widgets.SkeletonCard(lines = 3, title = stringResource(Res.string.todo_title)) }
    ) {
        TodoCardContent(state, actions, onMessageShown)
    }
}

@Composable
private fun TodoCardContent(state: TodoUiState, actions: TodoActions, onMessageShown: () -> Unit) {
    RegularCard(modifier = Modifier.fillMaxWidth().testTag(TODO_CARD_TAG)) {

        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    stringResource(Res.string.todo_title),
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy,
                    modifier = Modifier.weight(1f)
                )
                if (state.items.isNotEmpty()) {
                    Box(
                        Modifier.clip(CircleShape).background(DeepNavy).padding(horizontal = 10.dp, vertical = 2.dp),
                        contentAlignment = Alignment.Center
                    ) {
                        Text("${state.items.size}", style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold, color = Color.White)
                    }
                }
            }
            if (state.items.isEmpty()) {
                AllDone()
            } else {
                val today = AppClock.today()
                state.items.forEachIndexed { index, item ->
                    if (index > 0) HorizontalDivider(color = DeepNavy.copy(alpha = 0.08f))
                    val row = rowOf(item, state, actions)
                    TodoRowView(row, urgent = item.isUrgent(today), modifier = Modifier.testTag(todoItemTag(item.kind)), actionTag = todoActionTag(item.kind))
                }
            }
            // What the last inline action did ("Wysłane przypomnienia: 3"), for a few seconds.
            state.message?.let { message ->
                Text(message.asString(), style = MaterialTheme.typography.bodySmall, color = DeepNavy)
                LaunchedEffect(message) {
                    kotlinx.coroutines.delay(5_000)
                    onMessageShown()
                }
            }
        }
    }
}

private fun TodoItem.isUrgent(today: LocalDate): Boolean =
    due?.let { it <= today.plus(DatePeriod(days = TodoRules.URGENT_DAYS)) } == true

@Composable
private fun AllDone() {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Box(
            Modifier.size(44.dp).clip(CircleShape).background(DoneColor.copy(alpha = 0.12f)),
            contentAlignment = Alignment.Center
        ) {
            Icon(Icons.Default.TaskAlt, contentDescription = null, tint = DoneColor, modifier = Modifier.size(26.dp))
        }
        Spacer(Modifier.width(12.dp))
        Column {
            Text(stringResource(Res.string.todo_all_done), style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = DeepNavy)
            Text(stringResource(Res.string.todo_all_done_hint), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.75f))
        }
    }
}

/**
 * One row: the icon and the text first, then the action. The action stays beside the text only
 * while the whole text fits on its lines next to it (wide screens); otherwise the text takes the
 * row's full width (a long Polish title wraps between words, never inside one) and the action
 * goes on its own line under it, at the end (narrow phones).
 */
@Composable
private fun TodoRowView(row: TodoRow, urgent: Boolean, modifier: Modifier = Modifier, actionTag: String = "") {
    val tint = if (urgent) UrgentColor else DeepNavy
    ActionBesideOrBelow(
        modifier.fillMaxWidth(),
        text = {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Box(
                    Modifier.size(36.dp).clip(RoundedCornerShape(10.dp)).background(tint.copy(alpha = 0.10f)),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(row.icon, contentDescription = null, tint = tint, modifier = Modifier.size(20.dp))
                }
                Spacer(Modifier.width(12.dp))
                Column(Modifier.weight(1f, fill = false)) {
                    Text(row.title, style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.SemiBold, color = DeepNavy)
                    row.detail?.let {
                        Text(it, style = MaterialTheme.typography.bodySmall, color = if (urgent) UrgentColor else DeepNavy.copy(alpha = 0.75f))
                    }
                }
            }
        },
        action = if (row.actionLabel != null && (row.action != null || row.actionDone)) {
            {
                if (row.actionDone) {
                    Text(row.actionLabel, style = MaterialTheme.typography.labelMedium, color = DoneColor, fontWeight = FontWeight.SemiBold)
                } else {
                    Button(
                        onClick = { row.action?.invoke() },
                        modifier = Modifier.handCursor().testTag(actionTag),
                        shape = RoundedCornerShape(10.dp),
                        contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 12.dp, vertical = 6.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = DeepNavy, contentColor = Color.White)
                    ) {
                        Text(row.actionLabel, style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold)
                    }
                }
            }
        } else null
    )
}

/**
 * [text] and [action] side by side (both centred vertically, the action at the end) when the
 * text's natural width and the action fit in the row; else [text] at the full width and [action]
 * under it at the end. Uses the width there is, no breakpoint.
 */
@Composable
private fun ActionBesideOrBelow(modifier: Modifier, text: @Composable () -> Unit, action: (@Composable () -> Unit)?) {
    Layout(
        contents = listOf(text, action ?: {}),
        modifier = modifier
    ) { (textMeasurables, actionMeasurables), constraints ->
        val width = constraints.maxWidth
        val gap = 8.dp.roundToPx()
        val textMeasurable = textMeasurables.single()
        val actionPlaceable = actionMeasurables.firstOrNull()?.measure(constraints.copy(minWidth = 0, minHeight = 0))
        if (actionPlaceable == null) {
            val textPlaceable = textMeasurable.measure(constraints.copy(minWidth = 0, minHeight = 0))
            return@Layout layout(width, textPlaceable.height) { textPlaceable.place(0, 0) }
        }
        val besideWidth = width - actionPlaceable.width - gap
        val beside = besideWidth > 0 && textMeasurable.maxIntrinsicWidth(Constraints.Infinity) <= besideWidth
        if (beside) {
            val textPlaceable = textMeasurable.measure(Constraints(maxWidth = besideWidth))
            val height = maxOf(textPlaceable.height, actionPlaceable.height)
            layout(width, height) {
                textPlaceable.place(0, (height - textPlaceable.height) / 2)
                actionPlaceable.place(width - actionPlaceable.width, (height - actionPlaceable.height) / 2)
            }
        } else {
            val textPlaceable = textMeasurable.measure(Constraints(maxWidth = width))
            val top = textPlaceable.height + gap
            layout(width, top + actionPlaceable.height) {
                textPlaceable.place(0, 0)
                actionPlaceable.place(width - actionPlaceable.width, top)
            }
        }
    }
}

/** "8:00" from a planned "2026-02-11T08:00:00". */
private fun clockOf(iso: String): String = if (iso.length >= 16) iso.substring(11, 16) else iso

@Composable
private fun monthYear(year: Int, month: Int) = "${monthInSentence(month)} $year"

@Composable
private fun rowOf(item: TodoItem, state: TodoUiState, actions: TodoActions): TodoRow = when (item) {
    is TodoItem.PendingRequests -> TodoRow(
        Icons.Default.Inbox,
        stringResource(Res.string.todo_requests, item.count),
        item.due?.let { due ->
            item.firstName?.let { stringResource(Res.string.todo_earliest_named, it, dayAndMonth(due)) } ?: stringResource(Res.string.todo_earliest, dayAndMonth(due))
        },
        stringResource(Res.string.todo_requests_action),
        actions.openRequests
    )
    is TodoItem.ClockReviews -> TodoRow(
        Icons.Default.Timer,
        stringResource(Res.string.todo_clock_reviews, item.count),
        null,
        stringResource(Res.string.todo_clock_reviews_action),
        actions.showClockReview
    )
    is TodoItem.HoursToConfirm -> TodoRow(
        Icons.Default.Schedule,
        stringResource(Res.string.todo_hours_to_confirm, item.count),
        dayAndMonth(item.date),
        stringResource(Res.string.todo_hours_to_confirm_action),
        actions.openWorkHours?.let { open -> { open(item.workplaceId, item.date) } }
    )
    is TodoItem.MissingTakings -> TodoRow(
        Icons.Default.PointOfSale,
        stringResource(Res.string.todo_missing_takings, item.days.size),
        item.days.map { dayAndMonth(it) }.joinToString(", "),
        stringResource(Res.string.todo_missing_takings_action),
        actions.enterTakings?.let { enter -> { enter(item.workplaceId, item.first) } }
    )
    is TodoItem.MissingPay -> TodoRow(
        Icons.Default.Payments,
        stringResource(Res.string.todo_missing_pay, item.count),
        if (item.count > 1) stringResource(Res.string.todo_missing_pay_others, item.firstName) else item.firstName,
        stringResource(Res.string.missing_pay_set),
        actions.openPay?.let { open -> { open(item.workplaceId, item.firstUserId) } }
    )
    is TodoItem.UnfilledShifts -> TodoRow(
        Icons.Default.Groups,
        stringResource(Res.string.todo_unfilled, item.count),
        stringResource(Res.string.todo_earliest, dayAndMonth(item.first)),
        stringResource(Res.string.todo_open_roster),
        actions.openRoster?.let { open -> { open(item.rosterId) } }
    )
    is TodoItem.AvailabilityAnswers -> {
        val month = monthYear(item.year, item.month)
        val reminded = item.rosterId in state.reminded
        // The push text, in the sender's language (the app shows its own from the data).
        val pushTitle = stringResource(Res.string.capacity_reminder_title)
        val pushMessage = item.deadline?.let { stringResource(Res.string.capacity_reminder_message_due, monthInSentence(item.month), item.year, dayAndMonth(it)) }
            ?: stringResource(Res.string.capacity_reminder_message, monthInSentence(item.month), item.year)
        val remind = actions.remind?.takeIf { state.canRemind && item.remindable.isNotEmpty() }
        TodoRow(
            Icons.Default.EventAvailable,
            pluralStringResource(Res.plurals.todo_availability_answers, item.team, item.missing, item.team, month),
            item.deadline?.let { stringResource(Res.string.todo_deadline, dayAndMonth(it)) },
            when {
                reminded -> stringResource(Res.string.todo_reminded)
                remind != null -> pluralStringResource(Res.plurals.todo_remind, item.remindable.size, item.remindable.size)
                else -> stringResource(Res.string.todo_open)
            },
            when {
                reminded -> null
                remind != null -> { { remind(item, pushTitle, pushMessage) } }
                else -> actions.openCapacity?.let { open -> { open(item.rosterId) } }
            },
            actionDone = reminded
        )
    }
    // SH-263: a published month changed since says so (with how many), a draft waits for its first publish.
    is TodoItem.RosterToPublish -> TodoRow(
        Icons.Default.Publish,
        stringResource(if (item.hasChanges) Res.string.todo_publish_changes else Res.string.todo_publish, monthYear(item.year, item.month)),
        if (item.hasChanges) pluralStringResource(Res.plurals.roster_unpublished_count, item.changes, item.changes) else null,
        stringResource(Res.string.todo_open_roster),
        actions.openRoster?.let { open -> { open(item.rosterId) } }
    )
    is TodoItem.NextShift -> {
        val today = AppClock.today()
        val date = LocalDate.parse(item.shift.date)
        val day = when (date) {
            today -> stringResource(Res.string.todo_day_today)
            today.plus(DatePeriod(days = 1)) -> stringResource(Res.string.todo_day_tomorrow)
            else -> dayAndMonth(date)
        }
        val hours = (item.startsInMinutes / 60).toInt()
        val minutes = item.startsInMinutes.toInt()
        TodoRow(
            Icons.Default.Schedule,
            stringResource(Res.string.todo_next_shift, day, clockOf(item.shift.plannedTime.start)),
            if (hours >= 1) pluralStringResource(Res.plurals.todo_starts_in_hours, hours, hours)
            else pluralStringResource(Res.plurals.todo_starts_in_minutes, minutes, minutes),
            stringResource(Res.string.todo_my_shifts),
            actions.openMyShifts
        )
    }
    is TodoItem.AvailabilityDue -> TodoRow(
        Icons.Default.EditCalendar,
        stringResource(Res.string.todo_availability_due, monthYear(item.year, item.month)),
        item.deadline?.let { stringResource(Res.string.todo_deadline, dayAndMonth(it)) },
        stringResource(Res.string.todo_availability_fill),
        actions.openAvailability?.let { open -> { open(item.rosterId) } }
    )
    is TodoItem.SwapsAsked -> TodoRow(
        Icons.Default.SwapHoriz,
        if (item.count == 1) stringResource(Res.string.todo_swap_asked, item.firstName, dayAndMonth(item.first))
        else stringResource(Res.string.todo_swaps_asked, item.count),
        if (item.count == 1) null else stringResource(Res.string.todo_earliest_named, item.firstName, dayAndMonth(item.first)),
        stringResource(Res.string.todo_view),
        actions.openMyShifts
    )
    is TodoItem.SwapRejected -> TodoRow(
        Icons.Default.SwapHoriz,
        stringResource(Res.string.todo_swap_rejected, dayAndMonth(item.date)),
        null,
        stringResource(Res.string.todo_view),
        actions.openMyShifts
    )
    is TodoItem.PoliciesToConfirm -> TodoRow(
        Icons.Default.Description,
        stringResource(Res.string.todo_policies, item.count),
        item.firstTitle,
        stringResource(Res.string.todo_policies_action),
        actions.openPolicies?.let { open -> { open(item.workplaceId) } }
    )
    is TodoItem.OwnCheck -> TodoRow(
        if (item.check == StaffCheck.MEDICAL_EXAM) Icons.Default.Badge else Icons.Default.HealthAndSafety,
        stringResource(
            when (item.check) {
                StaffCheck.MEDICAL_EXAM -> if (item.expired) Res.string.todo_medical_expired else Res.string.todo_medical_expiring
                StaffCheck.OHS_TRAINING -> if (item.expired) Res.string.todo_ohs_expired else Res.string.todo_ohs_expiring
            },
            dayAndMonth(item.validUntil)
        ),
        null,
        stringResource(Res.string.todo_view),
        actions.openProfile
    )
    is TodoItem.Marketplace -> TodoRow(
        Icons.Default.Storefront,
        stringResource(Res.string.todo_marketplace, item.count),
        stringResource(Res.string.todo_earliest, dayAndMonth(item.first)),
        stringResource(Res.string.todo_marketplace_action),
        actions.openMarketplace
    )
}

